import S from "@babel/runtime/helpers/esm/get";
import x from "@babel/runtime/helpers/esm/getPrototypeOf";
import _ from "@babel/runtime/helpers/esm/objectSpread2";
import K from "@babel/runtime/helpers/esm/objectWithoutProperties";
import C from "@babel/runtime/helpers/esm/classCallCheck";
import A from "@babel/runtime/helpers/esm/createClass";
import d from "@babel/runtime/helpers/esm/assertThisInitialized";
import E from "@babel/runtime/helpers/esm/inherits";
import R from "@babel/runtime/helpers/esm/createSuper";
import l from "@babel/runtime/helpers/esm/defineProperty";
import { sstyled as L } from "@semcore/utils/lib/core/index";
import N, { CREATE_COMPONENT as j, assignProps as I, Component as X, sstyled as F } from "@semcore/core";
import i from "react";
import q from "@semcore/popper";
import { Box as B } from "@semcore/flex-box";
import z from "@semcore/utils/lib/enhances/resolveColorEnhance";
import { isAdvanceMode as U } from "@semcore/utils/lib/findComponent";
import Y from "@semcore/utils/lib/logger";
import D from "@semcore/utils/lib/uniqueID";
import G from "@semcore/portal";
import { useZIndexStacking as J, ZIndexStackingContextProvider as Q } from "@semcore/utils/lib/zIndexStacking";
var rr = ["Children", "title", "offset", "forcedAdvancedMode"], M = (
  /*__reshadow_css_start__*/
  (L.insert(
    /*__inner_css_start__*/
    '.___STooltip_th7kb_gg_{position:relative;padding:var(--intergalactic-spacing-3x, 12px);border-radius:var(--intergalactic-popper-rounded, 6px);box-sizing:border-box;color:var(--intergalactic-text-primary, #191b23);font-size:var(--intergalactic-fs-200, 14px);line-height:var(--intergalactic-lh-200, 142%);word-wrap:break-word;max-width:228px;font-weight:400;white-space:normal;box-shadow:var(--intergalactic-box-shadow-popper, 0px 1px 12px 0px rgba(25, 27, 35, 0.15));background-color:var(--intergalactic-tooltip-default, #ffffff);border:1px solid var(--intergalactic-border-secondary, #e0e1e9)}.___STooltip_th7kb_gg_._theme_invert_th7kb_gg_{color:var(--intergalactic-text-primary-invert, #ffffff);background-color:var(--intergalactic-tooltip-invert, #191b23);border:1px solid var(--intergalactic-border-tooltip-invert, #6c6e79)}.___STooltip_th7kb_gg_._theme_warning_th7kb_gg_{background-color:var(--intergalactic-tooltip-warning, #ffd7df);border:1px solid var(--intergalactic-border-critical-active, #d1002f)}.___SArrow_th7kb_gg_{position:absolute;border:6px solid;border-color:var(--intergalactic-border-secondary, #e0e1e9)}.___SArrow_th7kb_gg_:before{content:"";position:absolute;border:6px solid;border-color:var(--intergalactic-tooltip-default, #ffffff)}.___SArrow_th7kb_gg_._theme_invert_th7kb_gg_{border-color:var(--intergalactic-border-tooltip-invert, #6c6e79)}.___SArrow_th7kb_gg_._theme_invert_th7kb_gg_::before{border-color:var(--intergalactic-tooltip-invert, #191b23)}.___SArrow_th7kb_gg_._theme_warning_th7kb_gg_{border-color:var(--intergalactic-border-critical-active, #d1002f)}.___SArrow_th7kb_gg_._theme_warning_th7kb_gg_::before{border-color:var(--intergalactic-tooltip-warning, #ffd7df)}.___SArrow_th7kb_gg_.__bgColor_th7kb_gg_{border-color:var(--shadowColor_th7kb)}.___SArrow_th7kb_gg_.__bgColor_th7kb_gg_::before{border-color:var(--bgColor_th7kb)}.___STooltip_th7kb_gg_[data-popper-placement^=top] .___SArrow_th7kb_gg_,.___STooltip_th7kb_gg_[data-popper-placement^=top] .___SArrow_th7kb_gg_::before{top:100%;border-bottom:0 transparent;border-right-color:transparent!important;border-left-color:transparent!important}.___STooltip_th7kb_gg_[data-popper-placement^=top] .___SArrow_th7kb_gg_::before{top:-7px;left:-6px}.___STooltip_th7kb_gg_[data-popper-placement^=bottom] .___SArrow_th7kb_gg_{bottom:100%;border-top:0 transparent;border-right-color:transparent!important;border-left-color:transparent!important}.___STooltip_th7kb_gg_[data-popper-placement^=bottom] .___SArrow_th7kb_gg_::before{top:1px;left:-6px;border-top:0 transparent;border-right-color:transparent!important;border-left-color:transparent!important}.___STooltip_th7kb_gg_[data-popper-placement^=left] .___SArrow_th7kb_gg_,.___STooltip_th7kb_gg_[data-popper-placement^=left] .___SArrow_th7kb_gg_::before{left:100%;border-right:0 transparent;border-top-color:transparent!important;border-bottom-color:transparent!important}.___STooltip_th7kb_gg_[data-popper-placement^=left] .___SArrow_th7kb_gg_::before{top:-6px;left:-7px}.___STooltip_th7kb_gg_[data-popper-placement^=right] .___SArrow_th7kb_gg_{right:100%;border-left:0 transparent;border-top-color:transparent!important;border-bottom-color:transparent!important}.___STooltip_th7kb_gg_[data-popper-placement^=right] .___SArrow_th7kb_gg_::before{top:-6px;left:1px;border-left:0 transparent;border-top-color:transparent!important;border-bottom-color:transparent!important}.___STooltipPortalledWrapper_th7kb_gg_{position:absolute;width:100vw;left:calc(-50vw + 50%)}',
    "th7kb_gg_"
  ), {
    __STooltip: "___STooltip_th7kb_gg_",
    _theme_invert: "_theme_invert_th7kb_gg_",
    _theme_warning: "_theme_warning_th7kb_gg_",
    __STooltipPortalledWrapper: "___STooltipPortalledWrapper_th7kb_gg_",
    __SArrow: "___SArrow_th7kb_gg_",
    _bgColor: "__bgColor_th7kb_gg_",
    "--shadowColor": "--shadowColor_th7kb",
    "--bgColor": "--bgColor_th7kb"
  })
), m = q[j](), W = {
  placement: "top",
  interaction: "hover",
  timeout: [100, 50],
  offset: [0, 10],
  flip: {
    flipVariations: !0,
    flipVariationsByContent: !0
  },
  defaultVisible: !1,
  focusLoop: !1,
  liveRegion: !0
}, h = /* @__PURE__ */ function(p) {
  E(t, p);
  var s = R(t);
  function t() {
    var o;
    C(this, t);
    for (var r = arguments.length, a = new Array(r), e = 0; e < r; e++)
      a[e] = arguments[e];
    return o = s.call.apply(s, [this].concat(a)), l(d(o), "state", {
      popperChildren: null
    }), l(d(o), "subcomponents", [u.Trigger.displayName, u.Popper.displayName]), l(d(o), "defaultChildren", function(n, c, g) {
      return /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(u.Trigger, g, /* @__PURE__ */ i.createElement(c, null)), /* @__PURE__ */ i.createElement(u.Popper, null, n));
    }), o;
  }
  return A(t, [{
    key: "uncontrolledProps",
    value: function() {
      var r = this;
      return {
        visible: [null, function(a) {
          var e;
          (e = r.handlePopperVisibleChange) === null || e === void 0 || e.call(r, a);
        }]
      };
    }
  }, {
    key: "getTriggerProps",
    value: function() {
      var r = this.asProps, a = r.uid, e = r.visible, n = e ? "igc-".concat(a, "-popper") : void 0;
      return {
        "aria-haspopup": void 0,
        "aria-describedby": n,
        popperId: n
      };
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var r = this.asProps, a = r.theme, e = r.uid, n = r.liveRegion, c = r.disablePortal, g = r.ignorePortalsStacking, b = r.interaction, f = r.resolveColor, y = r.visible, k = a === "warning" ? "assertive" : "polite";
      return n || (k = void 0), {
        id: "igc-".concat(e, "-popper"),
        theme: a,
        disablePortal: c,
        ignorePortalsStacking: g,
        interaction: b,
        resolveColor: f,
        role: "tooltip",
        "aria-live": k,
        visible: y
      };
    }
  }, {
    key: "render",
    value: function() {
      var r = this.asProps, a = this.asProps, e = a.Children, n = a.title;
      a.offset;
      var c = a.forcedAdvancedMode, g = K(a, rr), b = c || U(e, this.subcomponents);
      return Y.warn(n && b, "You can't use 'title' and '<Tooltip.Trigger/>/<Tooltip.Popper/>' at the same time", g["data-ui-name"] || u.displayName), /* @__PURE__ */ i.createElement(m, I({}, r), b ? /* @__PURE__ */ i.createElement(e, null) : this.defaultChildren(n, e, g));
    }
  }]), t;
}(X);
l(h, "displayName", "Tooltip");
l(h, "style", M);
l(h, "enhance", [D(), z()]);
l(h, "defaultProps", _({}, W));
function $(p) {
  var s = arguments[0], t, o = p.Children, r = p.styles, a = m.Trigger;
  return t = F(r), /* @__PURE__ */ i.createElement(a, t.cn("STrigger", _({}, I({}, s))), /* @__PURE__ */ i.createElement(o, t.cn("Children", {})));
}
function V(p) {
  var s = arguments[0], t, o = p.Children, r = p.styles, a = p.theme, e = p.resolveColor, n = p.disablePortal, c = p.ignorePortalsStacking, g = p["aria-live"], b = p.arrowBgColor, f = p.arrowShadowColor, y = m.Popper, k = B, H = B, O = J("z-index-tooltip"), Z = p.zIndex || O;
  return t = F(r), /* @__PURE__ */ i.createElement(Q, t.cn("ZIndexStackingContextProvider", {
    designToken: "z-index-tooltip"
  }), /* @__PURE__ */ i.createElement(G, t.cn("Portal", {
    disablePortal: n,
    ignorePortalsStacking: c
  }), /* @__PURE__ */ i.createElement(H, t.cn("STooltipPortalledWrapper", {
    role: g === "polite" ? "status" : void 0,
    "aria-live": g,
    zIndex: Z
  }), /* @__PURE__ */ i.createElement(y, t.cn("STooltip", _({}, I({
    "use:disablePortal": !0,
    "use:theme": e(a),
    "use:aria-live": void 0,
    "use:zIndex": void 0
  }, s))), /* @__PURE__ */ i.createElement(o, t.cn("Children", {})), /* @__PURE__ */ i.createElement(k, t.cn("SArrow", {
    "data-popper-arrow": !0,
    "use:theme": e(a),
    bgColor: e(b),
    shadowColor: e(f ?? b)
  }))))));
}
var v = /* @__PURE__ */ function(p) {
  E(t, p);
  var s = R(t);
  function t() {
    var o;
    C(this, t);
    for (var r = arguments.length, a = new Array(r), e = 0; e < r; e++)
      a[e] = arguments[e];
    return o = s.call.apply(s, [this].concat(a)), l(d(o), "subcomponents", [T.Trigger.displayName, T.Popper.displayName]), l(d(o), "defaultChildren", function(n, c, g) {
      return /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(T.Trigger, g, /* @__PURE__ */ i.createElement(c, null)), /* @__PURE__ */ i.createElement(T.Popper, null, n));
    }), o;
  }
  return A(t, [{
    key: "getTriggerProps",
    value: function() {
      var r = S(x(t.prototype), "getTriggerProps", this).call(this);
      return _(_({}, r), {}, {
        "aria-describedby": void 0,
        "aria-label": this.asProps.title
      });
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var r = S(x(t.prototype), "getPopperProps", this).call(this);
      return _(_({}, r), {}, {
        "aria-hidden": !0,
        role: void 0,
        children: this.asProps.title
      });
    }
  }]), t;
}(h);
l(v, "displayName", "Hint");
l(v, "style", M);
l(v, "enhance", [D(), z()]);
l(v, "defaultProps", _(_({}, W), {}, {
  liveRegion: !1
}));
var P = /* @__PURE__ */ function(p) {
  E(t, p);
  var s = R(t);
  function t() {
    var o;
    C(this, t);
    for (var r = arguments.length, a = new Array(r), e = 0; e < r; e++)
      a[e] = arguments[e];
    return o = s.call.apply(s, [this].concat(a)), l(d(o), "popperRef", /* @__PURE__ */ i.createRef()), l(d(o), "subcomponents", [w.Trigger.displayName, w.Popper.displayName]), l(d(o), "defaultChildren", function(n, c, g) {
      return /* @__PURE__ */ i.createElement(i.Fragment, null, /* @__PURE__ */ i.createElement(w.Trigger, g, /* @__PURE__ */ i.createElement(c, null)), /* @__PURE__ */ i.createElement(w.Popper, null, n));
    }), l(d(o), "handleTriggerKeyDown", function(n) {
      o.asProps.interaction === "click" && (n.key === " " && ["INPUT", "TEXTAREA"].includes(n.target.tagName) || n.key === "Enter" && n.target.tagName === "TEXTAREA" || ["Enter", " "].includes(n.key) && (n.preventDefault(), o.handlers.visible(!0)));
    }), o;
  }
  return A(t, [{
    key: "getTriggerProps",
    value: function() {
      var r = this.asProps, a = r.disabled, e = r.visible, n = S(x(t.prototype), "getTriggerProps", this).call(this);
      return _(_({}, n), {}, {
        "aria-haspopup": a || n.disabled ? "false" : "dialog",
        "aria-expanded": e,
        "aria-describedby": void 0,
        "aria-controls": e ? "igc-".concat(this.asProps.uid, "-popper") : void 0,
        onKeyDown: this.handleTriggerKeyDown,
        role: "button"
      });
    }
  }, {
    key: "getPopperProps",
    value: function() {
      var r = S(x(t.prototype), "getPopperProps", this).call(this);
      return _(_({}, r), {}, {
        ref: this.popperRef,
        role: "dialog",
        tabIndex: 0,
        autoFocus: "enforced"
      });
    }
  }]), t;
}(h);
l(P, "displayName", "DescriptionTooltip");
l(P, "style", M);
l(P, "enhance", [D(), z()]);
l(P, "defaultProps", _(_({}, W), {}, {
  liveRegion: !1,
  interaction: "click"
}));
var T = N(v, {
  Trigger: $,
  Popper: V
}, {
  parent: m
}), u = N(h, {
  Trigger: $,
  Popper: V
}, {
  parent: m
}), w = N(P, {
  Trigger: $,
  Popper: V
}, {
  parent: m
});
export {
  w as DescriptionTooltip,
  T as Hint,
  u as Tooltip,
  u as default
};
